import React, { SVGProps } from 'react';

const RoundedAlertIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.32439 1.52942V1.52942C12.077 1.52942 15.1185 4.57092 15.1185 8.32354V8.32354C15.1185 12.0762 12.077 15.1177 8.32439 15.1177V15.1177C4.57177 15.1177 1.53027 12.0762 1.53027 8.32354V8.32354C1.53027 4.57092 4.57177 1.52942 8.32439 1.52942Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8.32374 8.70096V4.92645" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8.32299 11.3431C8.21881 11.3431 8.13426 11.4277 8.13502 11.5319C8.13502 11.636 8.21957 11.7206 8.32374 11.7206C8.42792 11.7206 8.51247 11.636 8.51247 11.5319C8.51247 11.4277 8.42792 11.3431 8.32299 11.3431"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RoundedAlertIcon;
